<div class="bluescreen" *ngIf="showSideBar">
  <h3 class="brand-name">Loading</h3> <span class="d">.</span><span class="d d-2">.</span><span class="d d-3">.</span>
</div>

<div class="wrapper">
  <div id="left-menu" class="main-menu" *ngIf="router.url !== '/login'">
    <ngx-neo-app-navbar></ngx-neo-app-navbar>
  </div>
  <div class="page-content">
    <div class="header-content" *ngIf="router.url !== '/login'">
      <ngx-neo-app-header [enableHelp]="false">
        <div headerLogo>
          <div class="d-inline">
            <span class="app-logo">
              <img src="{{link}}/assets/images/tenant-header-logo.png" alt="Bcone-Logo"   onerror='this.onerror = null; this.src="assets/images/bcone-logo2.png"'/>
            </span>
            <span class="header-app-name" i18n>NEO Logs
            </span>
          </div>
        </div>
        <div navigationLink>
          <ul class="customNav"><li></li></ul>
        </div>
      </ngx-neo-app-header>
    </div>
    <div [ngClass]="(router.url !== '/login') ? ('main-content') : ''">
      <router-outlet></router-outlet>
    </div>
    <div *ngIf="router.url !== '/login'">
      <ngx-neo-app-footer></ngx-neo-app-footer>
    </div>
  </div>
</div>
<ngx-loading-bar [includeSpinner]='false'></ngx-loading-bar>
<ngx-neo-app-privacy-policy></ngx-neo-app-privacy-policy>